import { Button, Container, Stack, Text, Title, Box, Group } from "@mantine/core";
import { IconLock, IconClock } from "@tabler/icons-react";

type Pagina1Properties = {
  onAvancar: () => void;
};

const Pagina1 = ({ onAvancar }: Pagina1Properties) => {
  return (
    <Container size="sm" py="xl">
      <Stack gap="xl" align="center">
        {/* Logo Section */}
        <Box ta="center">
          <Title order={1} size="2.5rem" fw={700} c="gray.8" mb="xs" style={{ lineHeight: 1.2 }}>
            Bem-vindo à votação do Prêmio Empresa Inspiradora!
          </Title>
        </Box>

        <Box maw={600} ta="center">
          <Text size="lg" c="gray.7" mb="md" style={{ lineHeight: 1.6 }}>
            <Text component="span" fw={600}>
              O Prêmio Empresa Inspiradora{" "}
            </Text>
            é uma celebração especial, complementar ao{" "}
            <Text component="span" fw={600}>
              Prêmio Empresa Inovadora{" "}
            </Text>
            (nossa premiação principal!). Seu objetivo é reconhecer as empresas que mais se destacaram aos olhos do
            público quando o assunto é{" "}
            <Text component="span" fw={600}>
              inovação.
            </Text>
          </Text>

          <Text size="lg" c="gray.7" mb="md" style={{ lineHeight: 1.6 }}>
            Contamos com o seu voto para eleger as favoritas nas categorias:{" "}
            <Text component="span" fw={600}>
              Indústria, Cooperativas, Tecnologia e Comunicação, e Serviços.
            </Text>
          </Text>

          <Text fw={600} size="lg" c="gray.8">
            Vamos votar?!
          </Text>
        </Box>

        <Button
          size="xl"
          radius="lg"
          onClick={onAvancar}
          variant="filled"
          styles={{
            root: {
              background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
              border: "none",
              padding: "1rem 2.5rem",
              fontSize: "1.25rem",
              fontWeight: 600,
              boxShadow: "0 10px 25px -5px rgba(59, 130, 246, 0.3)",
              transition: "all 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 15px 35px -5px rgba(59, 130, 246, 0.4)",
                background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)"
              }
            }
          }}
        >
          Comece Aqui
        </Button>
        <Group gap="xs">
          <Group gap="xs">
            <IconLock size={16} color="#6b7280" />
            <Text size="sm" c="gray.5">
              Seus dados estão seguros conosco
            </Text>
          </Group>
          <Group gap="xs">
            <IconClock size={16} color="#6b7280" />
            <Text size="sm" c="gray.5">
              Leva apenas 3 minutos para completar
            </Text>
          </Group>
        </Group>
      </Stack>
    </Container>
  );
};

export default Pagina1;
